import React from 'react';
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import Header from '../../components/common/Header';

// Mock data for the dashboard
const mockStats = [
  { title: 'Total Managers', value: 245 },
  { title: 'Total Investors', value: 1892 },
  { title: 'Active Products', value: 357 },
  { title: 'Connections', value: 3214 }
];

const mockRecentUsers = [
  { id: 1, name: 'John Smith', email: 'john.smith@example.com', role: 'Manager', date: '2023-04-01' },
  { id: 2, name: 'Sarah Johnson', email: 'sarah.j@example.com', role: 'Investor', date: '2023-03-29' },
  { id: 3, name: 'Robert Williams', email: 'rob.w@example.com', role: 'Manager', date: '2023-03-28' },
  { id: 4, name: 'Jessica Brown', email: 'jessica.b@example.com', role: 'Investor', date: '2023-03-27' },
  { id: 5, name: 'Michael Davis', email: 'michael.d@example.com', role: 'Investor', date: '2023-03-26' }
];

const AdminDashboard = () => {
  return (
    <Box sx={{ flexGrow: 1, height: '100vh', overflow: 'auto' }}>
      <Header />
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom component="h1">
          Admin Dashboard
        </Typography>
        
        {/* Stats Cards */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {mockStats.map((stat, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card>
                <CardContent>
                  <Typography variant="h6" component="div">
                    {stat.title}
                  </Typography>
                  <Typography variant="h3" component="div" sx={{ mt: 2 }}>
                    {stat.value}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
        
        {/* Recent Users */}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom component="h2">
                Recent Users
              </Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Role</TableCell>
                      <TableCell>Registered Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {mockRecentUsers.map((user) => (
                      <TableRow key={user.id}>
                        <TableCell>{user.name}</TableCell>
                        <TableCell>{user.email}</TableCell>
                        <TableCell>{user.role}</TableCell>
                        <TableCell>{user.date}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AdminDashboard;
